// ============================================================
// Rabattpreis auf der Produktseite — 1InstaPhone Shop-Theme
//
// WAS ES TUT: Wer ueber einen Rabattlink kommt (/discount/CODE), sieht
// den Rabatt schon auf der Produktseite, nicht erst im Warenkorb:
//   Prozent-Code:  alter Preis durchgestrichen, neuer Preis daneben,
//                  darunter gruener Kasten "Du sparst 30 % (6,87 €)" und
//                  klein "Gutscheincode CODE aktiv".
//   Kaufe X, erhalte Y (z.B. 1PLUS1): Preis bleibt stehen, darunter ein
//                  Hinweis. Ein Streichpreis pro Stueck waere hier falsch,
//                  der Nachlass entsteht erst ab dem zweiten Stueck.
//
// WOHER DER WERT KOMMT: Shopifys Cookie `discount_code` enthaelt nur den
// Namen des Codes. Was er wert ist, steht in der Liste im Snippet
// snippets/bf-rabatt-preis.liquid (JSON-Block #bf-rabatt-preis-daten).
// Steht der Code dort nicht, ist er abgelaufen oder gilt er fuer dieses
// Produkt nicht: es passiert nichts, der normale Preis bleibt.
//
// RECHNUNG: wie an der Kasse. Nachlass je Stueck auf den Cent ABGERUNDET,
// 22,90 EUR minus 30 % = 22,90 - 6,87 = 16,03 EUR (Checkout 25.09.2026),
// 8,99 EUR minus 30 % = 8,99 - 2,69 = 6,30 EUR (Warenkorb 23.10.2026).
// Gerechnet wird mit dem Preis, der gerade angezeigt wird. Damit stimmt
// es auch nach einem Modellwechsel.
//
// NUR IN EURO: Ist die Warenkorb-Waehrung nicht EUR, passiert nichts.
// Transcy rechnet nur die Anzeige im Browser um (Warenkorb bleibt EUR);
// dann rechnen wir auf dem umgerechneten Betrag, das Verhaeltnis stimmt.
//
// MODELLWECHSEL: Das Theme (Focal) schreibt den Preis bei jedem
// Variantenwechsel neu. Ein Beobachter setzt den Rabattpreis danach
// wieder ein.
//
// EINBAU: snippets/bf-rabatt-preis.liquid laedt diese Datei. Das Snippet
// wird an einer Stelle gerendert, die auf jeder Seite laedt. Bei 1Insta:
// sections/pdx-drawer.liquid (dort haengt auch bf-bundle). Allgemein:
// layout/theme.liquid vor dem schliessenden body-Tag.
//
// RUNDUNG: je Stueck, Shopify rechnet je Zeile. Bei mehreren Stueck kann
// die Kasse hoechstens um Cent-Bruchteile je Zeile guenstiger sein, nie teurer.
// ============================================================

(function () {
  'use strict';

  var MARKE = 'data-bf-rabatt-preis';
  var HINWEIS_ID = 'bf-rabatt-preis-hinweis';
  var BETRAG = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/;

  function codeAusCookie() {
    var treffer = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!treffer) return null;
    try {
      var wert = decodeURIComponent(treffer[1]).trim();
      return /^[A-Za-z0-9_-]{2,40}$/.test(wert) ? wert : null;
    } catch (e) {
      return null;
    }
  }

  function datenLesen() {
    var el = document.getElementById('bf-rabatt-preis-daten');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Shopify-Codes sind unabhaengig von Gross-/Kleinschreibung.
  function eintragFinden(daten, code) {
    var codes = daten.codes || {};
    var gesucht = code.toUpperCase();
    for (var name in codes) {
      if (Object.prototype.hasOwnProperty.call(codes, name) && name.toUpperCase() === gesucht) {
        return codes[name];
      }
    }
    return null;
  }

  function imZeitraum(eintrag) {
    var jetzt = Date.now();
    if (eintrag.von && !(Date.parse(eintrag.von) <= jetzt)) return false;
    if (eintrag.bis && !(jetzt <= Date.parse(eintrag.bis))) return false;
    return true;
  }

  function giltFuerProdukt(eintrag, daten) {
    if (!eintrag.kollektion) return true;
    return (daten.kollektionen || []).indexOf(eintrag.kollektion) !== -1;
  }

  function inCent(text) {
    var m = text.match(BETRAG);
    if (!m) return null;
    return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
  }

  function alsBetrag(cent) {
    var euro = String(Math.floor(cent / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var rest = String(cent % 100);
    return euro + ',' + (rest.length < 2 ? '0' + rest : rest);
  }

  // Ersetzt in einem kopierten Preis-Element nur die Zahl, Waehrungszeichen
  // und Aufbau bleiben wie vom Theme geliefert.
  function zahlErsetzen(el, neu) {
    var gehen = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var knoten;
    while ((knoten = gehen.nextNode())) {
      if (BETRAG.test(knoten.nodeValue)) {
        knoten.nodeValue = knoten.nodeValue.replace(BETRAG, neu);
        return true;
      }
    }
    return false;
  }

  function stilEinsetzen() {
    if (document.getElementById('bf-rabatt-preis-stil')) return;
    var stil = document.createElement('style');
    stil.id = 'bf-rabatt-preis-stil';
    // Optik nach Patricks Vorlage 22.10.: neuer Preis rot und gross, alter
    // Preis grau durchgestrichen, darunter gruener Kasten mit der Ersparnis.
    stil.textContent = [
      // Eigene Klasse statt price--compare: die Produktseiten-Optik (pdx,
      // "Preis-Optik") blendet price--compare im Preisbereich bewusst aus.
      '.bf-rp-neu{color:#d4183d !important;font-weight:600;}',
      '.bf-rp-alt{color:#8a8a8a !important;text-decoration:line-through;}',
      // Der Preisbereich ist eine Zeile (flex). Der Kasten bekommt eine
      // eigene, volle Zeile darunter.
      '#' + HINWEIS_ID + '{flex-basis:100%;width:100%;margin:10px 0 4px;}',
      '#' + HINWEIS_ID + ' .bf-rp-kasten{display:inline-block;background:#3f6b1f;color:#fff;',
      'border-radius:10px;padding:8px 16px;font-size:15px;font-weight:600;line-height:1.3;}',
      '#' + HINWEIS_ID + ' .bf-rp-code-zeile{display:block;margin-top:6px;font-size:12.5px;',
      'color:#3f6b1f;line-height:1.35;}',
      '#' + HINWEIS_ID + ' .bf-rp-code{letter-spacing:.04em;}'
    ].join('');
    (document.head || document.documentElement).appendChild(stil);
  }

  // Kasten unter dem Preis. Liegt ausserhalb der Preisliste, damit das
  // Theme ihn beim Modellwechsel nicht wegschreibt. Gibt den Kasten zurueck,
  // damit die Ersparnis nach einem Modellwechsel neu gesetzt werden kann.
  function hinweisSetzen(liste, code) {
    var vorhanden = document.getElementById(HINWEIS_ID);
    if (vorhanden) return vorhanden.querySelector('.bf-rp-kasten');
    var hinweis = document.createElement('div');
    hinweis.id = HINWEIS_ID;
    var kasten = document.createElement('span');
    kasten.className = 'bf-rp-kasten';
    hinweis.appendChild(kasten);
    var zeile = document.createElement('span');
    zeile.className = 'bf-rp-code-zeile';
    zeile.appendChild(document.createTextNode('✓ Gutscheincode '));
    var b = document.createElement('b');
    b.className = 'bf-rp-code';
    b.textContent = code;          // als Text, nie als HTML
    zeile.appendChild(b);
    zeile.appendChild(document.createTextNode(' aktiv'));
    hinweis.appendChild(zeile);
    // Am Handy ist der Preis mittig, am Desktop links: der Kasten folgt.
    var reihe = liste.parentNode;
    var mittig = window.getComputedStyle(reihe).justifyContent === 'center';
    hinweis.style.textAlign = mittig ? 'center' : 'left';
    reihe.style.flexWrap = 'wrap';
    reihe.insertBefore(hinweis, liste.nextSibling);
    return kasten;
  }

  // Betrag im Format des Theme (Waehrungszeichen, Abstand) ohne Vorlese-Text.
  function betragWieTheme(preisEl, cent) {
    var kopie = preisEl.cloneNode(true);
    var weg = kopie.querySelectorAll('.visually-hidden');
    for (var i = 0; i < weg.length; i++) weg[i].parentNode.removeChild(weg[i]);
    if (!zahlErsetzen(kopie, alsBetrag(cent))) return alsBetrag(cent) + ' €';
    return kopie.textContent.replace(/\s+/g, ' ').trim();
  }

  // Prozent-Code: neuer Preis vorne, bisheriger Preis durchgestrichen.
  // Gibt den Ersparnis-Text zurueck, '' wenn schon gesetzt, null wenn die
  // Liste nicht so aussieht wie erwartet.
  function prozentAnwenden(liste, prozent) {
    if (liste.querySelector('[' + MARKE + ']')) return '';
    var preis = liste.querySelector('.price:not(.price--compare)');
    if (!preis) return null;
    var alt = inCent(preis.textContent);
    if (alt === null || alt <= 0) return null;
    // Abrunden wie Shopify: 8,99 mit 30 % = 2,69 Rabatt, Kasse 6,30 (23.10.2026).
    // Die Seite darf nie weniger versprechen, als die Kasse nimmt.
    var nachlass = Math.floor(alt * prozent / 100 + 1e-9);
    var neu = alt - nachlass;
    if (neu <= 0 || nachlass <= 0) return null;

    var neuEl = preis.cloneNode(true);
    if (!zahlErsetzen(neuEl, alsBetrag(neu))) return null;
    neuEl.classList.add('price--highlight', 'bf-rp-neu');
    neuEl.setAttribute(MARKE, 'neu');

    // Ein schon vorhandener Streichpreis (Sale im Admin) wuerde neben
    // unserem einen zweiten durchgestrichenen Preis zeigen.
    var vorhanden = liste.querySelectorAll('.price--compare');
    for (var i = 0; i < vorhanden.length; i++) vorhanden[i].style.display = 'none';

    var ersparnis = 'Du sparst ' + prozent + ' % (' + betragWieTheme(preis, nachlass) + ')';

    preis.classList.remove('price--highlight', 'price--large');
    preis.classList.add('bf-rp-alt');
    preis.setAttribute(MARKE, 'alt');
    var vorlesen = preis.querySelector('.visually-hidden');
    if (vorlesen) vorlesen.textContent = 'Preis ohne Gutscheincode';

    liste.insertBefore(neuEl, preis);
    return ersparnis;
  }

  function start() {
    var code = codeAusCookie();
    if (!code) return;
    var daten = datenLesen();
    if (!daten || daten.waehrung !== 'EUR') return;
    var eintrag = eintragFinden(daten, code);
    if (!eintrag || !imZeitraum(eintrag) || !giltFuerProdukt(eintrag, daten)) return;

    var listen = document.querySelectorAll('[data-product-price-list]');
    if (!listen.length) return;

    if (eintrag.art === 'x_gratis') {
      if (!eintrag.hinweis) return;
      stilEinsetzen();
      hinweisSetzen(listen[0], code.toUpperCase()).textContent = eintrag.hinweis;
      return;
    }
    if (eintrag.art !== 'prozent') return;
    var prozent = Number(eintrag.wert);
    if (!(prozent > 0 && prozent < 100)) return;

    Array.prototype.forEach.call(listen, function (liste, nr) {
      var ersparnis = prozentAnwenden(liste, prozent);
      if (!ersparnis) return;
      stilEinsetzen();
      var kasten = nr === 0 ? hinweisSetzen(liste, code.toUpperCase()) : null;
      if (kasten) kasten.textContent = ersparnis;
      if (!window.MutationObserver) return;
      // Nach jedem Neuschreiben durch das Theme erneut einsetzen und die
      // Ersparnis im Kasten nachziehen. Die Obergrenze verhindert ein
      // Pingpong mit einer App, die den Preis ebenfalls umschreibt.
      var runden = 0;
      var beobachter = new MutationObserver(function () {
        if (liste.querySelector('[' + MARKE + '="neu"]')) return;
        if (++runden > 50) { beobachter.disconnect(); return; }
        beobachter.disconnect();
        try {
          var neu = prozentAnwenden(liste, prozent);
          if (neu && kasten) kasten.textContent = neu;
        } catch (e) {}
        beobachter.observe(liste, { childList: true, subtree: true, characterData: true });
      });
      beobachter.observe(liste, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
